import {
  OFFER_INCREMENT_STEP,
  OFFER_DECREMENT_STEP,
  OFFER_SET_CURRENT_STEP,
  OFFER_UPDATE_PARAMS,
  OFFER_UPDATE,
  OFFER_COOKIE_SUCCESS,
  OFFER_UPDATE_OPERATION,
  PRECONTRACT_UPDATE,
  OFFER_CREATE_OPERATION_DATA,
  OFFER_RESULT_INSTANTOR,
  OFFER_UPDATE_DOCUMENTS_REQUIRED,
  OFFER_UPDATE_SIGN,
  OFFER_LEGAL_CONDITIONS,
  OFFER_REGISTER_SIGNATURE,
  OFFER_COMPONENTS_BY_PARTNER_ID,
  OFFER_UPDATE_COMPLETED_KO
} from 'store/actions/offer';
import { dateToISO } from 'helpers/date';
import { number, currency } from 'helpers/number';

export default {
  [OFFER_INCREMENT_STEP]: state => {
    state.currentStep += 1;
  },

  [OFFER_DECREMENT_STEP]: state => {
    state.currentStep -= 1;
  },

  [OFFER_SET_CURRENT_STEP]: (state, currentStep) => {
    state.currentStep = currentStep;
  },

  [OFFER_UPDATE_PARAMS]: (state, resp) => {
    const { idOffer, partnerId, idc, trackerClickId, guid, orderId, accessToken } = resp;
    state.idOffer = Number(idOffer);
    state.idc = idc ? Number(idc) : 0;
    state.partnerId = Number(partnerId);
    state.orderId = orderId;
    state.accessToken = accessToken;
    state.trackerClickId = trackerClickId;
    state.guidURL = guid || orderId;
  },

  [OFFER_COOKIE_SUCCESS]: (state, resp) => {
    state.statusCookie = resp.idStatus;
    state.referenceNumber = resp.referenceNumber;
  },

  // eslint-disable-next-line complexity
  [OFFER_UPDATE]: (state, offer) => {
    state.offer = offer;
    const {
      serviceList,
      campaignDetail,
      partnerId,
      car,
      campaignType,
      insuranceTypes,
      operationOwner,
      marketPlaceOrderId
    } = offer;
    if (partnerId) state.partnerId = Number(partnerId);
    if (campaignDetail && campaignDetail.channel && campaignDetail.channel.length > 0) {
      state.amazonChannel = campaignDetail.channel.indexOf('Amazon') > -1;
    }

    // Created offer detail object
    const {
      make,
      model,
      version,
      rangeKms,
      legalText,
      urlPhoto,
      monthFee,
      insuranceMonthFee,
      totalAmountToBePaid,
      vehicleType,
      doors,
      accessories,
      settings,
      termInMonths,
      yearKms,
      downPayment,
      warrantyFee,
      warrantyFeeDescription,
      stock
    } = campaignDetail;
    const hasTotalAmount = insuranceMonthFee && totalAmountToBePaid;
    // Bulletpoints
    const bulletPoints = car.bulletPoints || [];
    let extraInformation = '';
    bulletPoints.forEach((element, index) => {
      if (index === 0) extraInformation = '<ul>';
      extraInformation += `<li>${element}</li>`;
      if (bulletPoints.length - 1 === index) extraInformation += '</ul>';
    });
    state.offerDetail = {
      campaignType,
      stock,
      title: `${make} ${model}`,
      subTitle: version,
      badgeCampaignType: car && car.vehicleStatus ? car.vehicleStatus : null,
      badgeColor: car && car.colorName ? `Color ${car.colorName}` : null,
      badgeRangeKms: rangeKms,
      legal: legalText,
      photos: urlPhoto,
      value: hasTotalAmount ? `${currency(totalAmountToBePaid)}/mes` : `${currency(monthFee)}/mes`,
      rentingFee: hasTotalAmount ? `${currency(monthFee)}/mes` : '',
      insuranceFee: hasTotalAmount ? `${currency(insuranceMonthFee)}/mes` : '',
      properties: [
        {
          name: 'Tipo:',
          description: `${vehicleType || ''} ${doors} puertas.`
        },
        {
          name: 'Opciones incluidas:',
          description: accessories
        },
        {
          name: 'Servicios incluidos:',
          description: serviceList
        },
        {
          name: 'Ajustes de kilometraje:',
          description: settings
        }
      ],
      features: [
        {
          title: 'Plazo',
          value: `${termInMonths} meses`,
          icon: 'ald-ico-clock'
        },
        {
          title: 'Km/año',
          value: number(yearKms),
          icon: 'ald-ico-odometer'
        }
      ],
      extraInformation,
      vehiculoRtsV2: car.vehiculoRtsV2 || ''
    };

    if (warrantyFeeDescription) {
      state.offerDetail.properties.push({
        name: 'A la firma del contrato:',
        description: warrantyFeeDescription
      });
    }

    if (downPayment != null) {
      state.offerDetail.features.push({
        title: 'Pago inicial',
        value: currency(downPayment),
        icon: 'ald-ico-euro'
      });
    }

    if (warrantyFee != null) {
      state.offerDetail.features.push({
        title: 'Depósito en garantía',
        value: currency(warrantyFee),
        icon: 'coins'
      });
    }
    state.insuranceTypes = insuranceTypes;
    // marketPlaceOrderId
    if (marketPlaceOrderId) {
      state.marketPlaceOrderId = marketPlaceOrderId;
    }
    // operationOwner
    if (operationOwner) {
      state.operationOwner = operationOwner;
    }
  },

  [OFFER_UPDATE_OPERATION]: (state, { quoteId, operationId, referenceNumber }) => {
    state.idOffer = quoteId;
    state.idOperation = operationId;
    state.referenceNumber = referenceNumber;
  },

  [OFFER_COMPONENTS_BY_PARTNER_ID]: (state, data) => {
    state.componentsCMS = data;
  },

  [OFFER_REGISTER_SIGNATURE]: (state, { url, message }) => {
    state.completedUrlDocument = url;
    state.completedMessage = message;
  },

  [OFFER_LEGAL_CONDITIONS]: (state, conditions) => {
    state.legalConditions = conditions;
  },

  [OFFER_CREATE_OPERATION_DATA]: (state, data) => {
    const sendData = data;
    delete sendData.signRequest;
    sendData.prospect.contact.forEach(element => {
      /* eslint-disable no-param-reassign */
      const { birthDate, driverLicenseIssuedDate } = element;
      if (birthDate) element.birthDate = dateToISO(birthDate);
      if (driverLicenseIssuedDate)
        element.driverLicenseIssuedDate = dateToISO(driverLicenseIssuedDate);
    });
    sendData.idC = state.idc;
    sendData.quoteId = state.idOffer;
    // Comentado porque se pidio que fuese el mismo que viene en la URL y no el que devuelve el endpoint campaignFront
    // sendData.partnerId = state.partnerId;
    sendData.trackerClickId = state.trackerClickId;
    if (state.orderId) {
      sendData.operationGuid = state.orderId;
    }
    state.createOperationData = sendData;
  },

  [OFFER_UPDATE_SIGN]: (state, { guid, data }) => {
    const singRequest = data;
    singRequest.id = guid;
    state.singRequestData = singRequest;
  },

  [OFFER_RESULT_INSTANTOR]: (state, idRequestInstanstor) => {
    state.idRequestInstanstor = idRequestInstanstor;
  },

  [OFFER_UPDATE_DOCUMENTS_REQUIRED]: (state, { documentsRequired, identification }) => {
    state.documentsRequired = documentsRequired;
    state.identification = identification;
  },

  [PRECONTRACT_UPDATE]: (state, precontract) => {
    state.precontract = precontract;
  },

  [OFFER_UPDATE_COMPLETED_KO]: (state, statusKo) => {
    state.statusKo = statusKo;
  }
};
